import React, { useState, useEffect } from 'react'
import Markdown from 'markdown-to-jsx'
import { Global } from '@emotion/core'
import { appPath } from '@fs/zion-config'
import axios from '@fs/zion-axios'
import { useTranslation } from 'react-i18next'
import { createMarkdownStyles } from '../../../../assets/markdownStyles'

const markdownStyles = createMarkdownStyles('guide-markdown')

export default function PlaceReportsGuide(): JSX.Element {
  const [t] = useTranslation()
  const [guideContent, setGuideContent] = useState('')
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchGuide() {
      try {
        const response = await axios.get(`${appPath}/place-reports/markdown-content/?filename=place_report_guide.md`)
        if (response.status === 200) {
          setGuideContent(response.data.content)
          setError(false)
        }
      } catch {
        // Silently fail and show error message to user
        setGuideContent('')
        setError(true)
      } finally {
        setLoading(false)
      }
    }
    fetchGuide()
  }, [])

  if (loading) {
    return (
      <>
        <Global styles={markdownStyles} />
        <div className="guide-markdown">
          <p>{t('place-reports.place-reports-guide.loading.message', 'Loading...')}</p>
        </div>
      </>
    )
  }

  if (error) {
    return (
      <>
        <Global styles={markdownStyles} />
        <div className="guide-markdown">
          <h1>{t('place-reports.place-reports-guide.error.header', 'Error')}</h1>
          <p>{t('place-reports.place-reports-guide.unable-to-load.message', 'Unable to load the user guide.')}</p>
        </div>
      </>
    )
  }

  return (
    <>
      <Global styles={markdownStyles} />
      <div className="guide-markdown">
        <Markdown>{guideContent}</Markdown>
      </div>
    </>
  )
}
